import React, { useEffect, useState } from 'react';
import '../../styles/model.css';
import { Select, Form, Button, DatePicker, Row, Col } from 'antd';
import axios from '../../util/axiosConfig';
import dayjs from 'dayjs';
import moment from 'moment';
const { RangePicker } = DatePicker;

interface ModalProps {
  isOpen: boolean;
  onClose: (data?: any) => void;
  pdfUrl: string | null;
  from: string;
}


const Modals: React.FC<ModalProps> = ({ isOpen, onClose, pdfUrl, from }) => {
  const MultiSelectForm = () => {
    const [selectedvendor, setVendorSelectedOptions] = useState<string[]>([]);
    const [vendorList, setVendorlist] = useState<any[]>([]);
    const [selectedstatus, setStatusSelectedOptions] = useState<string[]>([]);
    const [StatusList, setStatuslist] = useState<any[]>([]);
    const [ReasonList, setReasonlist] = useState<any[]>([]);
    const [selectedReason, setReasonSelectedOptions] = useState<string[]>([]);
    const [PlantList, setPlantlist] = useState<any[]>([]);
    const [selectedPlant, setPlantSelectedOptions] = useState<string[]>([]);
    const [DocumentList, setDocumentlist] = useState<any[]>([]);
    const [selectedDocument, setDocumentSelectedOptions] = useState<string[]>([]);
    const [PurchaseList, setPurchaselist] = useState<any[]>([]);
    const [selectedPurchase, setPurchaseSelectedOptions] = useState<string[]>([]);
    // const [dates, setDates] = useState<[dayjs.Dayjs, dayjs.Dayjs] | null>(null);
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const handleDateChange = (dates: any, dateStrings: [string, string]) => {
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
      // setDates(dates);;
    };

    const handleVendorChange = (values: string[]) => {
      setVendorSelectedOptions(values);
    };
    const handleStatusChange = (values: string[]) => {
      setStatusSelectedOptions(values);
    };

    const handleReasonChange = (values: string[]) => {
      setReasonSelectedOptions(values);
    };

    const handlePlantChange = (values: string[]) => {
      if (values.includes('all')) {
        // If "Select All" is selected, select all options
        if (selectedPlant.length === PlantList.length) {
          setTimeout(() => {
            setPlantSelectedOptions([]); // Deselect all
          }, 300);
          
        } else {
          setPlantSelectedOptions(PlantList?.map(option => option.id));
        }
      } else {
        // Set the selected options (excluding "Select All")
        setPlantSelectedOptions(values);
      }
    };

    const handleDocumentChange = (values: string[]) => {
      if (values.includes('all')) {
        // If "Select All" is selected, select all options
        if (selectedDocument.length === DocumentList.length) {
          setTimeout(() => {
            setDocumentSelectedOptions([]); // Deselect all
          }, 300);
          
        } else {
          setDocumentSelectedOptions(DocumentList?.map(option => option.id));
        }
      } else {
        // Set the selected options (excluding "Select All")
        setDocumentSelectedOptions(values);
      }
    };

    const handlePurchaseChange = (values: string[]) => {
      if (values.includes('all')) {
        // If "Select All" is selected, select all options
        if (selectedPurchase.length === PurchaseList.length) {
          setTimeout(() => {
            setPurchaseSelectedOptions([]); // Deselect all
          }, 300);
          
        } else {
          setPurchaseSelectedOptions(PurchaseList?.map(option => option.id));
        }
      } else {
        // Set the selected options (excluding "Select All")
        setPurchaseSelectedOptions(values);
      }
    };

    const clearFilter = (event: any) => {
      event.preventDefault();
      localStorage.removeItem('FilterData');
      onClose(null)
    }

    const handleSubmit = (event: any) => {
      event.preventDefault();      
      let filterData = {
        "vendorNameList":
          selectedvendor
        ,
        "statusList":
          selectedstatus
        ,
        "disputeReasonList":
          selectedReason
        ,
        "fromDate": startDate ? startDate : null,
        "toDate": endDate ? endDate : null,
        "plantList":
          selectedPlant
        ,
        "documentTypeList":
          selectedDocument
        ,
        "purchaseGroupList":
          selectedPurchase
      }
      localStorage.setItem('FilterData', JSON.stringify(filterData))
      onClose(filterData)
    };

    useEffect(() => {

      fetchVendorList();
      fetchStatusList();
      fetchReasonList();
      fetchPlantList();
      fetchDocumentList();
      fetchPurchaseList();
      let FData = localStorage.getItem('FilterData')
      let filterData = FData ? JSON.parse(FData) : null
      if(filterData){   
        // console.log(filterData, 'filterData');
      setStartDate(filterData.fromDate ? filterData.fromDate.toString() : '');
      setEndDate(filterData.toDate ? filterData.toDate.toString() : '');
      setVendorSelectedOptions(filterData.vendorNameList);
      setStatusSelectedOptions(filterData.statusList);
      setReasonSelectedOptions(filterData.disputeReasonList);
      setDocumentSelectedOptions(filterData.documentTypeList);
      setPurchaseSelectedOptions(filterData.purchaseGroupList);
      setPlantSelectedOptions(filterData.plantList);
      console.log(startDate, endDate, 'datess');
      }

    }, [])

    const fetchVendorList = async () => {
      try {
        const response = await axios.get(`/vendor-list`, {
        });
        if (response?.data) {
          setVendorlist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }

    const fetchStatusList = async () => {
      try {
        const response = await axios.get(`/status-list`, {
        });
        if (response?.data) {
          setStatuslist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }

    const fetchReasonList = async () => {
      try {
        const response = await axios.get(`/dispute-reason/list`, {
        });
        if (response?.data) {
          setReasonlist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }

    const fetchPlantList = async () => {
      try {
        const response = await axios.get(`/plant/get-all-plants`, {
        });
        if (response?.data) {
          setPlantlist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }

    const fetchDocumentList = async () => {
      try {
        const response = await axios.get(`/po-document-type/get-all-po-document-type`, {
        });
        if (response?.data) {
          setDocumentlist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }

    const fetchPurchaseList = async () => {
      try {
        const response = await axios.get(`/purchase-group/get-all-purchase-group`, {
        });
        if (response?.data) {
          setPurchaselist(response?.data?.data)

        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }


    return (
      <form onSubmit={handleSubmit}>
        <div className='Filter-fields'>
          <label>Vendor:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedvendor} onChange={handleVendorChange}>
              {vendorList?.map((vendor) => (
                <option key={vendor.name} value={vendor.name}>
                  {vendor.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='Filter-fields'>
          <label>Status:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedstatus} onChange={handleStatusChange}>
              {StatusList?.map((status) => (
                <option key={status.name} value={status.name}>
                  {status.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='Filter-fields'>
          {/* <label>From and To Dates:</label> */}
          <div className='filterSelects'>
            <Form.Item
              label="Select date range"
              name="dateRange"
              rules={[{ required: true, message: 'Please select a date range!' }]}
            >
              <RangePicker
                format="YYYY-MM-DD"
                onChange={handleDateChange}
                value={[
                  startDate ? dayjs(startDate, 'YYYY-MM-DD') : null,
                  endDate ? dayjs(endDate, 'YYYY-MM-DD') : null,
                ]} // Controlled component
              />
               <p hidden>Start Date: {startDate}</p>
               <p hidden>End Date: {endDate}</p>
            </Form.Item>
          </div>
        </div>
        <div className='Filter-fields'>
          <label>Dispute Reason:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedReason} onChange={handleReasonChange}
              optionFilterProp="key"
            >
              {ReasonList?.map((reason) => (
                <option key={reason.name} value={reason.id}>
                  {reason.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        {/* <div className='Filter-fields'>
          <label>Plant:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedPlant} onChange={handlePlantChange} optionFilterProp="key">
            <option key="all" value="all">
          {selectedPlant?.length === PlantList?.length ? 'Un Select All' : 'Select All'}
        </option>
              {PlantList.map((Plant) => (
                <option key={Plant.name} value={Plant.id}>
                  {Plant.name} - {Plant.code}
                </option>
              ))}
            </Select>
          </div>
        </div> */}
        <div className='Filter-fields'>
          <label>Document:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedDocument} onChange={handleDocumentChange} optionFilterProp="key">
            <option key="all" value="all">
          {selectedDocument?.length === DocumentList?.length ? 'Un Select All' : 'Select All'}
        </option>
              {DocumentList?.map((Document) => (
                <option key={Document.docType} value={Document.id}>
                  {Document.docType}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='Filter-fields'>
          <label>Purchase:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedPurchase} onChange={handlePurchaseChange} optionFilterProp="key">
            <option key="all" value="all">
          {selectedPurchase?.length === PurchaseList?.length ? 'Un Select All' : 'Select All'}
        </option>
              {PurchaseList?.map((Purchase) => (
                <option key={Purchase.name} value={Purchase.id}>
                  {Purchase.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='FilterSubmitted'>
          <Button type="primary" className='filterSubmit' onClick={handleSubmit}>Apply Filter</Button>
          <Button type="default" className='clearButton' onClick={clearFilter}>Clear</Button>
        </div>
      </form>
    );
  };
  const DashboardForm = () => {
    const [selectedvendor, setVendorSelectedOptions] = useState<string[]>([]);
    const [vendorList, setVendorlist] = useState<any[]>([]);
    useEffect(() => {
      fetchVendorList();
      let FData = localStorage.getItem('dashboardFilterData')
      let dashboardFilterData = FData ? JSON.parse(FData) : null
      if(dashboardFilterData){       
      setVendorSelectedOptions(dashboardFilterData.vendorNameList);
      }
    },[])
    const fetchVendorList = async () => {
      try {
        const response = await axios.get(`/vendor-list`, {
        });
        if (response?.data) {
          setVendorlist(response?.data?.data)
        }
      } catch (error) {
        console.error('Failed to fetch invoice data:', error);
      }
    }
    const handleVendorChange = (values: string[]) => {
      setVendorSelectedOptions(values);
    };
    const handleSubmit = (event: any) => {
      event.preventDefault();      
      let dashboardFilterData = {
        "vendorNameList":
          selectedvendor
      }
      localStorage.setItem('dashboardFilterData', JSON.stringify(dashboardFilterData))
      onClose(dashboardFilterData)
    }
    const clearFilter = (event: any) => {
      event.preventDefault();
      localStorage.removeItem('dashboardFilterData');
      onClose(null)
    }
    return (
      <form onSubmit={handleSubmit}>
        <div className='Filter-fields'>
          <label>Vendor:</label>
          <div className='filterSelects'>
            <Select mode="multiple" value={selectedvendor} onChange={handleVendorChange}>
              {vendorList?.map((vendor) => (
                <option key={vendor.name} value={vendor.name}>
                  {vendor.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className='FilterSubmitted'>
          <Button type="primary" className='filterSubmit' onClick={handleSubmit}>Apply Filter</Button>
          <Button type="default" className='clearButton' onClick={clearFilter}>Clear</Button>
        </div>
      </form>
    );
  }
  if (!isOpen) {
    return null;
  }
  if (from == 'filter') {
    return (
      <div className='filterModal'>
        <div className="modal-overlay">
          <div className="Filtermodal-content">
            <Row >
              <Col span="12"><h4>Filters</h4></Col>
              <Col span="12"><button className="modal-close" onClick={onClose}>
                &times;
              </button></Col>
            </Row>

            <div className="filter-container">
              {MultiSelectForm()}
            </div>
          </div>
        </div>
      </div>
    )
  } else if(from == 'dashboard'){
    return (
    <div className='filterModal'>
        <div className="modal-overlay">
          <div className="Filtermodal-content">
            <Row >
              <Col span="12"><h4>Filters</h4></Col>
              <Col span="12"><button className="modal-close" onClick={onClose}>
                &times;
              </button></Col>
            </Row>

            <div className="filter-container">
              {DashboardForm()}
            </div>
          </div>
        </div>
      </div>
    )
  }
  else {
    if (!isOpen || !pdfUrl) return null;
    return (
      <div className="modal-overlay pdfView">
        ()
        <div className="modal-content">
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
          <div className="pdf-container">
            <object data={pdfUrl} type="application/pdf" width="100%" height="600px">
              <p>Your browser does not support PDFs.
                <a href={pdfUrl} target="_blank" rel="noopener noreferrer">Download the PDF</a>
              </p>
            </object>
          </div>
        </div>
      </div>
    );
  }
};

export default Modals;
